<template>
  <button
    v-if="!expert.terms_signed_at"
    type="button"
    class="btn btn-sm btn-warning ms-1 terms-reminder-btn"
    data-bs-toggle="tooltip"
    :title="reminderTooltip"
    :disabled="loading"
    @click.stop.prevent="sendTermsReminder"
  >
    <i
      v-if="loading"
      class="fa fa-spinner fa-spin"
    />
    <i
      v-else
      class="fa fa-bell"
    />
    <span
      v-if="reminderCount > 0"
      class="terms-reminder-count"
    >{{ reminderCount }}</span>
  </button>
</template>

<script>
import mixin from "../../../mixins/mixin";

export default {
  name: 'ExpertTermsReminderButton',
  mixins: [mixin],
  props: {
    expert: {
      type: Object,
      required: true
    },
    projectTitle: {
      type: String,
      default: ''
    },
    projectId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      reminderCount: this.expert.terms_reminder_count || 0,
      lastReminderAt: this.expert.last_terms_reminder_at || null,
      lastReminderBy: this.expert.last_terms_reminder_by || null
    }
  },
  computed: {
    reminderTooltip() {
      if (this.reminderCount > 0) {
        let text = `Reminders sent: ${this.reminderCount}`;
        if (this.lastReminderAt) {
          text += ` · last ${this.formatDate(this.lastReminderAt)}`;
        }
        if (this.lastReminderBy) {
          text += ` by ${this.lastReminderBy}`;
        }
        return text;
      }
      return 'Send Terms & Conditions Reminder';
    }
  },
  methods: {
    async sendTermsReminder() {
      if (this.loading) return;

      this.loading = true;

      try {
        const projectTitle = this.projectTitle;
        const response = await axios.post('/api/v1/expert/send-terms-reminder', {
          expert_id: this.expert.id,
          project_title: projectTitle || null,
          project_id: this.projectId
        });

        if (response.data.success) {
          if (typeof response.data.reminder_count === 'number') {
            this.reminderCount = response.data.reminder_count;
          } else {
            this.reminderCount += 1;
          }
          this.lastReminderAt = new Date().toISOString();

          One.helpers("jq-notify", {
            type: "success",
            icon: "fa fa-check me-1",
            message: response.data.message
          });

          this.$emit('reminder-sent', response.data);
        } else {
          One.helpers("jq-notify", {
            type: "danger",
            icon: "fa fa-times me-1",
            message: response.data.message
          });
        }
      } catch (error) {
        let message = 'Failed to send terms reminder email. Please try again.';

        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }

        One.helpers("jq-notify", {
          type: "danger",
          icon: "fa fa-times me-1",
          message: message
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.terms-reminder-btn {
  font-size: 12px;
  padding: 2px 6px;
}
.terms-reminder-count {
  margin-left: 3px;
  font-weight: 600;
}
</style>
